export default __webpack_public_path__ + "static/blog1-338fee55d19f74c79bec15bf39b45825.jpeg";